// import $ from "jquery";

// $(".card").on("click", (e) => {
// 	console.log(e.target);
// 	$("#videoPopup").fadeIn(300);
// 	$("#videoPlayer").attr("src", $(e.currentTarget).data("src"));
// });

// $("#videoOverlay, #close").on("click", (e) => {
// 	e.stopPropagation();
// 	$("#videoPopup").fadeOut(200);
// 	$("#videoPlayer").attr("src", "");
// });

// $("#dialog").on("click", (e) => {
// 	e.stopPropagation();
// });

window.videoPopup = function () {
	return {
		show: false,
		videoSrc: "",
		open(src) {
			this.show = true;
			this.setVideoSrc(src);
		},
		close() {
			this.show = false;
			this.setVideoSrc("");
		},
		isOpen() {
			return this.show === true;
		},
		setVideoSrc(src) {
			setTimeout(() => this.videoSrc = src, 200)
		},
		getVideoSrc() {
			return this.videoSrc;
		},
	};
};
